export default __webpack_public_path__ + "static/media/köide-19-20.2868dddd.png";